// TODO: Altlast?
/*export const Routes = {
  Root: "/",
  SignIn: "/login",
  ResetPassword: "/reset",
  NewPassword: "/new-password",
  Audits: {
    List: "/audits"
  }
};*/

import Home from "./views/Home.vue";
import TemplateMatrix from "./views/TemplateMatrix.vue";
import Template from "./views/Template.vue";
import TemplatePreparation from "./components/widgets/TemplatePreparation.vue";
import Auditmatrix from "./views/Auditmatrix.vue";
import Audit from "./views/Audit.vue";
const AuditPreparation = () => ({
  // The component to load (should be a Promise)
  component: import("./components/widgets/AuditPreparation.vue"),
  // A component to use while the async component is loading
  loading: Signin,
  // A component to use if the load fails
  error: Signin,
  // Delay before showing the loading component. Default: 200ms.
  delay: 200,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 3000
});
//const AuditPreparation = () => import('./components/widgets/AuditPreparation.vue')
const AuditExecution = () => import("./components/widgets/AuditExecution.vue");
const AuditWrapUp = () => import("./components/widgets/AuditWrapUp.vue");
const AuditReporting = () => import("./components/widgets/AuditReporting.vue");
const AuditActionlist = () =>
  import("./components/widgets/AuditActionlist.vue");
//import AuditPreparation from "./components/widgets/AuditPreparation.vue";
//import AuditExecution from "./components/widgets/AuditExecution.vue";
//import AuditWrapUp from "./components/widgets/AuditWrapUp.vue";
//import AuditReporting from "./components/widgets/AuditReporting.vue";
import Standards from "./views/Standards.vue";
import Standard from "./views/Standard.vue";
import Measures from "./views/Measures.vue";

import AuditMeasureComponent from "./components/dialogs/AuditMeasureComponent.vue";
import AuditMetadataDialog from "./components/dialogs/AuditMetadataDialog.vue";
import Signin from "./views/Signin.vue";
import ResetPassword from "./views/ResetPassword.vue";
// import Signup from "./views/Signup.vue";
import CameraView from "./components/controls/CameraView";

import Users from "./views/Users.vue";
import User from "./views/User.vue";

import Configuration from "./views/Configuration.vue";
import CustomerData from "./views/CustomerData.vue";

const anyAccess = { anonymous: true, authorized: true };
// const unauthorizedOnlyAccess = { anonymous: true, authorized: false };

export default [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/auditmatrix",
    name: "auditmatrix",
    component: Auditmatrix
  },
  {
    path: "/audit/:auditId",
    name: "audit",
    component: Audit,
    props: true,
    redirect: "/audit/:auditId/auditpreparation",
    children: [
      {
        props: true,
        path: "auditpreparation",
        name: "auditpreparation",
        component: AuditPreparation
      },
      {
        props: true,
        path: "auditexecution",
        name: "auditexecution",
        component: AuditExecution
      },
      {
        props: true,
        path: "auditwrapup",
        name: "auditwrapup",
        component: AuditWrapUp
      },
      {
        props: true,
        path: "auditreporting",
        name: "auditreporting",
        component: AuditReporting
      },
      {
        props: true,
        path: "auditactionlist",
        name: "auditactionlist",
        component: AuditActionlist
      }
    ]
  },
  {
    path: "/audit/:id/edit",
    name: "auditedit",
    components: {
      dialog: AuditMetadataDialog
    }
  },
  {
    path: "/camera",
    name: "camera",
    component: CameraView
  },
  {
    path: "/templates",
    name: "templates",
    component: TemplateMatrix
  },
  {
    props: true,
    path: "/templates/:templateId",
    name: "templateid",
    component: Template
  },
  {
    props: true,
    path: "/templates/:templateId/templatepreparation",
    name: "templatepreparation",
    component: TemplatePreparation
  },
  {
    path: "/standards",
    name: "standards",
    component: Standards
  },
  {
    path: "/measures",
    name: "measures",
    component: Measures,
    children: [
      {
        path: ":id",
        name: "measure",
        component: AuditMeasureComponent
      }
    ]
  },
  {
    path: "/measure/:id",
    name: "measuredialog",
    components: {
      dialog: AuditMeasureComponent
    }
  },
  {
    props: true,
    path: "/standard/:standardId",
    name: "standard",
    component: Standard
  },
  {
    path: "/signin",
    name: "signin",
    component: Signin,
    meta: anyAccess
  },
  /* DISABLE SIGNUP{
    path: "/signup",
    name: "signup",
    component: Signup,
    meta: anyAccess
  },*/
  {
    path: "/resetpassword",
    name: "resetpassword",
    component: ResetPassword,
    meta: anyAccess
  },
  {
    path: "/users",
    name: "users",
    component: Users
  },
  {
    path: "/users/create",
    name: "usercreate",
    component: User
  },
  {
    props: true,
    path: "/user/:userId",
    name: "user",
    component: User
  },
  {
    path: "/configuration",
    name: "configuration",
    component: Configuration
  },
  {
    path: "/customerdata",
    name: "customerdata",
    component: CustomerData
  }
];
